import memoCoverDefault from "public/img/defaults/memo-placeholder.jpg";
import { useMemoCover } from "@models/interactions/use-memo-cover";
import type { MemoInterface } from "@carglassgithub/memod-sdk";
import { resizeImage } from "@models/interactions/utils";
import { useEffect, useMemo, useState } from "react";
import Loading from "@components/atoms/loading";
import Icon from "@components/atoms/icon";
import classNames from "classnames";
import Image from "next/image";

interface Props {
  memo: MemoInterface;
}

export function useCover(props: Props) {
  const [loading, setLoading] = useState(true);

  //@ts-ignore add this method t sdk
  const Serialized = props.memo?.type?.name === "Serialized";

  const { is_multi_part } = props.memo;

  const locked = Boolean(props.memo.is_locked === 0);

  useEffect(() => {
    return () => setLoading(true);
  }, [props.memo.id]);

  return {
    models: {
      loading,
      is_multi_part,
      Serialized,
      locked,
    },
    operations: {
      setLoading,
    },
  };
}

export default function CoverMemoCard(props: Props) {
  const { cover } = useMemoCover(props.memo.files);
  const { models, operations } = useCover(props);

  return cover ? (
    <section className="relative flex h-auto w-full">
      <span
        className={classNames(
          "absolute left-2/4 top-2/4 flex scale-150 items-center justify-center",
          {
            hidden: models.loading || !props.memo.is_locked,
          }
        )}
      >
        <Icon.Lock />
      </span>

      {models.is_multi_part || models.Serialized ? (
        <div className=" absolute left-3 top-3 flex h-5 w-[67px] items-center justify-center gap-1 rounded-xl bg-[#2c2c2e]">
          <span className="text-sm text-[#979797]">Multipart</span>
        </div>
      ) : null}

      <Image
        className={classNames(
          "img-container overflow-clip rounded-t-xl object-cover",
          {
            "!opacity-60": !models.locked,
            hidden: models.loading,
          }
        )}
        style={{ height: "auto", width: 274, minWidth: 274 }}
        onLoadingComplete={() => operations.setLoading(false)}
        src={
          cover?.attributes?.unique_name
            ? resizeImage(cover.attributes.unique_name)
            : cover.url
        }
        onLoad={() => operations.setLoading(true)}
        alt={cover.name}
        height={cover.size}
        width={274}
        priority
      />
      <div
        className={classNames(
          `flex h-[275px] w-full items-center justify-center`
        )}
      >
        <Loading
          size={45}
          className={classNames({ hidden: !models.loading })}
        />
      </div>
    </section>
  ) : (
    <section className="relative h-[250px] w-[274px]">
      <span
        className={classNames(
          "absolute left-2/4 top-2/4 z-10 flex scale-150 items-center justify-center",
          {
            hidden: models.loading || !props.memo.is_locked,
          }
        )}
      >
        <Icon.Lock />
      </span>
      <Image
        className={classNames(
          "img-container aspect-[11/10.05] rounded-t-xl object-cover",
          {
            "!opacity-60": !models.locked,
            hidden: models.loading,
          }
        )}
        onLoadingComplete={() => operations.setLoading(false)}
        onLoad={() => operations.setLoading(true)}
        alt={"Memo Default"}
        src={memoCoverDefault}
        width={274}
        height={250}
        priority
      />
    </section>
  );
}
